import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatDatePicker = createCustomElementWrapper('kat-date-picker', 'KatDatePicker', {
    'constraintEmphasis': 'constraint-emphasis',
    'constraintLabel': 'constraint-label',
    'katAriaLabel': 'kat-aria-label',
    'stateEmphasis': 'state-emphasis',
    'stateLabel': 'state-label',
    'tooltipPosition': 'tooltip-position',
    'tooltipText': 'tooltip-text',
    'tooltipTriggerIcon': 'tooltip-trigger-icon',
}, {
    'onChange': 'change',
    'onInvalid': 'invalid',
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/date-picker.js
// module id = 1209
// module chunks = 0